import React from 'react';
import { Handle, Position } from 'reactflow';
import { EMZI_COLORS, EMZI_RADIUS, EMZI_SPACING } from '../../styles/emziCI';
import PackChip from './PackChip';
import { txt } from '../../utils/bilingualText';

const ProductNode = ({ data }) => {
  return (
    <div
      style={{
        padding: EMZI_SPACING.md,
        borderRadius: EMZI_RADIUS.lg,
        backgroundColor: '#FFFFFF',
        border: `2px solid ${EMZI_COLORS.primary}`,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        minWidth: '220px',
        maxWidth: '300px',
      }}
    >
      {/* Product Header */}
      <div style={{ marginBottom: EMZI_SPACING.sm }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
          <span style={{ fontSize: '20px' }}>🧃</span>
          <span
            style={{
              fontSize: '10px',
              fontWeight: '600',
              textTransform: 'uppercase',
              color: EMZI_COLORS.primary,
              letterSpacing: '0.5px',
            }}
          >
            Product
          </span>
        </div>
        <h3
          style={{
            margin: 0,
            fontSize: '15px',
            fontWeight: '700',
            color: EMZI_COLORS.textPrimary,
            lineHeight: '1.3',
          }}
        >
          {txt(data.name, 'en', 'Untitled Product')}
        </h3>
      </div>

      {/* Product Details */}
      {data.description && (
        <p
          style={{
            margin: '0 0 12px 0',
            fontSize: '11px',
            color: EMZI_COLORS.textSecondary,
            lineHeight: '1.4',
          }}
        >
          {txt(data.description)}
        </p>
      )}

      {/* Price Tag */}
      {data.price && (
        <div
          style={{
            display: 'inline-block',
            padding: '4px 10px',
            backgroundColor: EMZI_COLORS.success + '20',
            color: EMZI_COLORS.success,
            borderRadius: EMZI_RADIUS.md,
            fontSize: '12px',
            fontWeight: '700',
            marginBottom: EMZI_SPACING.sm,
          }}
        >
          {data.price}
        </div>
      )}

      {/* Linked Knowledge Packs */}
      {data.linkedPacks && data.linkedPacks.length > 0 && (
        <div>
          <div
            style={{
              fontSize: '10px',
              fontWeight: '600',
              textTransform: 'uppercase',
              color: EMZI_COLORS.textMuted,
              marginBottom: '6px',
              letterSpacing: '0.5px',
            }}
          >
            Linked Packs ({data.linkedPacks.length})
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {data.linkedPacks.slice(0, 4).map((pack, idx) => (
              <PackChip key={`item-${idx}`} pack={pack} />
            ))}
            {data.linkedPacks.length > 4 && (
              <div
                style={{
                  padding: '4px 8px',
                  backgroundColor: EMZI_COLORS.surface,
                  borderRadius: EMZI_RADIUS.full,
                  fontSize: '10px',
                  color: EMZI_COLORS.textMuted,
                  fontWeight: '600',
                }}
              >
                +{data.linkedPacks.length - 4} more
              </div>
            )}
          </div>
        </div>
      )}

      {/* Connection Handles */}
      <Handle type="target" position={Position.Top} style={{ background: EMZI_COLORS.primary }} />
      <Handle type="source" position={Position.Bottom} style={{ background: EMZI_COLORS.primary }} />
    </div>
  );
};

export default ProductNode;
